export const cardHeadingThemes = {
  default: {
    thTitle: '',
    thTitleTheme: 'title-sans-3',
    thSmall: 'font-normal text-small ml-1',
    thSubtitle: '',
    thSubtitleTheme: 'title-sans-5',
  },
  destination: {
    thTitle: '',
    thTitleTheme: 'title-sans-6',
    thSmall: 'font-normal normal-case text-small ml-1',
    thSubtitle: '',
    thSubtitleTheme: 'title-sans-7',
  },
  landing: {
    thTitle: '',
    thTitleTheme: 'title-brand-11',
    thSmall: 'font-normal text-small ml-1',
    thSubtitle: '',
    thSubtitleTheme: 'title-sans-11',
  },
  thumbnail: {
    thTitle: '',
    thTitleTheme: 'title-brand-7',
    thSmall: 'font-normal text-small ml-1',
    thSubtitle: '',
    thSubtitleTheme: 'title-sans-12',
  },
};
